// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"f825ed42","845":"c25014a7"}[chunkId] + ".chunk.js";
};